export const abbreviateFirstName = (fullName: string): string => {
  const nameParts = fullName.replace(/\s+/g, ' ').split(' ');
  if (nameParts.length <= 1) {
    return fullName;
  }

  const abbreviatedParts = nameParts.slice(0, -1).map(part => part.charAt(0) + '.');
  const lastName = nameParts[nameParts.length - 1];

  return [...abbreviatedParts, lastName].join(' ');
};
